import { IsBoolean, IsNotEmpty } from "class-validator";

export class ScoreScratchDto {
  @IsNotEmpty()
  @IsBoolean()
  scratched: boolean;
}

